import React from "react";

/**
 * Error boundaries do not catch errors for:
 *
 * 1. Event handlers (learn more)
 * 2. Asynchronous code (e.g. setTimeout or requestAnimationFrame callbacks)
 * 3. Server side rendering
 * 4. Errors thrown in the error boundary itself (rather than its children)
 */
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		//   logErrorToMyService(error, errorInfo);
		console.log("caught error ", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return <h1>Something went wrong.</h1>;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
